




















































import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import {Prop, Watch} from 'vue-property-decorator';
import {cloneDeep, toString} from 'lodash';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';

@Component({
  mixins: [BindAttrs]
})
export default class DatatableListFilterTemplate extends Vue {

  @Prop() tableConfiguration!: DisguiseDto.DTTemplateDto;
  @Prop() inputConfiguration!: DisguiseDto.DTInputConfigurationDto;

  dynamicFieldResolver = DYNAMIC_FIELD_RESOLVER_INSTANCE;

  @Watch('inputConfiguration') modelChanges(newValue: DisguiseDto.DTInputConfigurationDto) {
    const colsWithFilter: DisguiseDto.DTInputColumnDto[] = [];
    for (const currentColumn of newValue.columns || []) {
      if (currentColumn.index !== undefined && currentColumn.sort) {
        colsWithFilter.push(currentColumn);
      }
    }
  }

  created() {
    const colsWithFilter: DisguiseDto.DTColumnsDto[] = [];
    let updateAdvancedFilter = false;
    const inputColumnConfiguration = cloneDeep(this.inputConfiguration.columns);
    for (const currentColumn of this.tableConfiguration.columns || []) {
      if (currentColumn.columnIndex !== undefined && currentColumn.sort) {
        colsWithFilter.push(currentColumn);
      }

      if (currentColumn.search) {
        if (currentColumn.columnIndex !== undefined && currentColumn.search.searchValues) {
          if (inputColumnConfiguration) {
            inputColumnConfiguration[currentColumn.columnIndex].searchValues = currentColumn.search.searchValues;
            inputColumnConfiguration[currentColumn.columnIndex].searchValue = '';
            updateAdvancedFilter = true;
          }
        }
      }
    }

    if (updateAdvancedFilter) {
      this.$emit('column-configuration-change', inputColumnConfiguration);
    }

  }

  /**
   * Handles the response from the advanced filter dialog.
   */
  applySimpleFilter(columnIndex: number, newSearchValue: string) {
    const inputColumnConfiguration = cloneDeep(this.inputConfiguration.columns);
    if (inputColumnConfiguration) {
      inputColumnConfiguration[columnIndex].searchValues = undefined;
      inputColumnConfiguration[columnIndex].searchValue = toString(newSearchValue);
      this.$emit('column-configuration-change', inputColumnConfiguration);
    }
  }

}
